import { UpdateServiceConfig } from "../types/update.types";
import { defaultConfig, DEFAULT_MESSAGES } from "./defaultConfig";

// Add type safety for dataset attributes
type UpdaterScriptAttributes = {
  versionFileUrl?: string;
  timeForUpdateOrPageReload?: string;
  checkInterval?: string;
  messagesTitle?: string;
  messagesDescription?: string;
  messagesAdditionalDescription?: string;
  currentVersion?: string;
};

export function getConfigFromScript(
  script: HTMLScriptElement
): UpdateServiceConfig {
  const dataset = script.dataset as UpdaterScriptAttributes;

  return {
    versionFileUrl: dataset.versionFileUrl ?? defaultConfig.versionFileUrl,
    timeForUpdateOrPageReload:
      dataset.timeForUpdateOrPageReload ??
      defaultConfig.timeForUpdateOrPageReload,
    checkInterval: dataset.checkInterval ?? defaultConfig.checkInterval,
    messages: {
      title: dataset.messagesTitle ?? DEFAULT_MESSAGES.title,
      description: dataset.messagesDescription ?? DEFAULT_MESSAGES.description,
      additionalDescription:
        dataset.messagesAdditionalDescription ??
        DEFAULT_MESSAGES.additionalDescription,
    },
    currentVersion: dataset.currentVersion ?? defaultConfig.currentVersion,
  };
}
